import Vue from 'vue'
import Vuex from 'vuex'
import loginPublic from './modules/loginPublic/index'
import publicModules from './modules/publicModules'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    publicModules,
    loginPublic
  }
})
